var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 32,
    viewBox: "0 0 15 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.70112 10.296V10.3077C7.09255 10.3077 8.4845 10.3023 9.87593 10.3097C10.786 10.3144 11.2155 10.7018 11.4072 11.589C11.5735 12.3607 11.3562 13.0861 11.2177 13.8273C10.6355 16.9453 10.0632 20.0655 9.49409 23.1857C9.31828 24.1495 9.1599 25.1171 9.00093 26.0841C8.97411 26.2466 8.98079 26.4165 8.98237 26.5822C9.00396 28.479 10.2034 28.7364 11.5781 28.1857C11.9664 28.0298 12.31 27.7636 12.6826 27.5636C13.3265 27.2186 13.6685 27.2088 13.9238 27.507C14.2333 27.8686 14.2055 28.4072 13.7539 28.9083C12.3114 30.5081 10.545 31.5015 8.36128 31.6505C7.16935 31.7316 5.97642 31.8096 4.79976 31.4874C2.64722 30.8971 1.20747 28.9294 1.48433 26.7189C1.75809 24.5325 2.17516 22.3643 2.53999 20.1896C2.85745 18.2975 3.19866 16.4089 3.50874 14.5157C3.55861 14.2096 3.5273 13.8823 3.48628 13.5714C3.41514 13.033 3.09037 12.6949 2.55659 12.5948C2.24326 12.5049 1.97581 12.5689 1.61421 12.4894C1.10739 12.3779 0.724184 12.2637 0.372023 12.0157C-0.204467 11.6092 -0.0881796 10.7843 0.563429 10.507C0.886078 10.3697 1.26348 10.3116 1.61714 10.3058C2.97809 10.2831 4.33965 10.296 5.70112 10.296Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13374 0.000119981C10.3868 -0.0175703 12.2988 1.92338 12.289 4.21692C12.2785 6.53537 10.4128 8.41882 8.12593 8.41907C5.83158 8.41906 3.95658 6.53954 3.95015 4.23157C3.94291 1.89938 5.80255 0.0185469 8.13374 0.000119981Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoAlt);
export default __webpack_public_path__ + "static/media/info-alt.9f08134c8ecbb44d45bd10ca11f38672.svg";
export { ForwardRef as ReactComponent };